import React from 'react';
import dummyHocComponent from 'env/LoadableComponent/DummyHocComponent';
import LoadableComponent from 'env/LoadableComponent/LoadableComponent';
import * as i18nextReact from 'react-i18next';

var window = require('global/window');
const r = require;

export const parseSource = async (source, depth = 0) => {
  window.exports = {};
  window.require = (name) => {
    if (name == 'react') return React;
    //To avoid recursinve calls to withCustomComponent
    else if (name == 'ui/components/withCustomComponent')
      return dummyHocComponent;
    else if (name == 'env/LoadableComponent/LoadableComponent')
      return (props) => {
        return <LoadableComponent {...props} depth={depth + 1} />;
      };
    else if (name == 'react-player') return r('react-player');
    else if (name == 'mobx-react') return r('mobx-react');
    else if (name == 'global') return r('global');
    else if (name == 'mobx') return r('mobx');
    else if (name == 'next/link') return r('next/link');
    else if (name == 'react-dom') return r('react-dom');
    else if (name == 'react-i18next') return i18nextReact;
    else if (name == 'i18next') return r('i18next');
    else if (name == 'text-clipper') return r('text-clipper');
    else if (name == 'prop-types') return r('prop-types');
    else if (name == 'next/router') return r('next/router');
    else if (name == 'next/head') return r('next/head');
    else if (name == 'query-string') return r('query-string');
    else if (name == 'react-recaptcha') return r('react-recaptcha');
    else if (name == 'reaptcha') return r('reaptcha');
    else if (name == 'react-markdown') return import('react-markdown');
    else if (name == 'react-widgets/DatePicker')
      return r('react-widgets/DatePicker');
    else if (name == 'turndown') return r('turndown');
    else if (name == '@fullcalendar/react') return r('@fullcalendar/react');
    else if (name == '@fullcalendar/daygrid') return r('@fullcalendar/daygrid');
    else if (name == '@fullcalendar/timegrid')
      return r('@fullcalendar/timegrid');
    else if (name == '@fullcalendar/interaction')
      return r('@fullcalendar/interaction');
    else if (name == '@fullcalendar/resource-timeline')
      return r('@fullcalendar/resource-timeline');
    else if (name == '@fullcalendar/list') return r('@fullcalendar/list');
    else if (name == '@react-google-maps/api')
      return r('@react-google-maps/api');
    else if (name == 'lodash') return r('lodash');
    else if (name == 'moment') return r('moment');
    else if (name == 'dequal') return r('dequal');
    else if (name == 'tiny-warning') return r('tiny-warning');
    else if (name == 'dom-helpers') return r('dom-helpers');
    else if (name == 'react-widgets') return r('react-widgets');
    else if (name == 'react-widgets/DropdownList')
      return r('react-widgets/DropdownList');
    else if (name == 'react-widgets/DatePicker')
      return r('react-widgets/DatePicker');
    else if (name == 'react-widgets/cjs') return r('react-widgets/cjs');
    else if (name == 'universal-cookie') return r('universal-cookie');
    else if (name == 'react-widgets-moment') return r('react-widgets-moment');
    else if (name == 'react-widgets/IntlLocalizer')
      return r('react-widgets/IntlLocalizer');
    else {
       throw Error(`Could not find component ${name}`);
    }
  };

  const renderTransformedCode = async () => {
    const transformedSource = (
      window.Babel ?? (await import('@babel/standalone'))
    ).transform(source, {
      presets: ['react', 'es2015', 'stage-3'],
      plugins: [
        ['proposal-decorators', { legacy: true }],
        ['proposal-class-properties', { loose: true }],
        ['proposal-private-methods', { loose: true }],
        ['proposal-private-property-in-object', { loose: true }],
      ],
    }).code;

    return window.eval(transformedSource);
  };

  return await renderTransformedCode();
};
